import { Table } from '@shinetools/lumen-react'
import type { TableSortDirection } from '@shinetools/lumen-react'
import { ReactElement, ReactNode } from 'react'

export interface TableHeaderColumn {
  id: string
  header: ReactNode
  sortable: boolean
  align?: 'start' | 'end'
  width?: string | number
}

interface TableHeaderProps<TColumn extends TableHeaderColumn> {
  columns: TColumn[]
  getSortDirection: (columnId: TColumn['id']) => TableSortDirection
  onSort: (columnId: TColumn['id']) => void
}

export const TableHeader = <TColumn extends TableHeaderColumn>({
  columns,
  getSortDirection,
  onSort,
}: TableHeaderProps<TColumn>): ReactElement => (
  <Table.Header>
    <Table.Row>
      {columns.map((column) => (
        <Table.HeaderCell
          key={column.id}
          align={column.align}
          sortable={column.sortable}
          sortDirection={getSortDirection(column.id)}
          onSort={column.sortable ? () => onSort(column.id) : undefined}
          width={column.width}
        >
          {column.header}
        </Table.HeaderCell>
      ))}
    </Table.Row>
  </Table.Header>
)
